import '@assets/main.css';
import '@pequity/shared/plugins/dayjs';
import { vWTooltip } from '@pequity/shared/ui';
import { isOidcSession } from '@pequity/shared/utils/oidc';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { LicenseManager } from 'ag-grid-enterprise';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from '@/App.vue';
import { scheduleOidcRefresh } from '@/composables/useOidcTokenRefresh';
import { setupAxiosInterceptors } from '@/plugins/axios';
import { I18nPlugin } from '@/plugins/i18n';
import { setupLayoutComponents } from '@/plugins/layout';
import { setupSentry } from '@/plugins/sentry';
import { router } from '@/router';

// Set the AG Grid Enterprise license key from SynergConfig
__SYNERG_READY__.then((cfg) => {
  LicenseManager.setLicenseKey(cfg.getKey('ag-grid-enterprise'));
});

const pinia = createPinia();

setupAxiosInterceptors();

const app = createApp(App);

setupLayoutComponents(app);

setupSentry(app, router);

app.use(pinia);

if (isOidcSession()) {
  scheduleOidcRefresh();
}

app.use(router);

app.use(VueQueryPlugin, {
  enableDevtoolsV6Plugin: true,
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  },
});

app.use(I18nPlugin);

app.directive('w-tooltip', vWTooltip);

app.mount('#app');
